import React, { useState } from 'react';
import { Input } from 'components';
import { useDebounce } from 'hooks';

interface IEmployeeSearchProps {
  defaultValue?: string;
  onSearch: (value: string) => void;
}

export const EmployeeSearch: React.FC<IEmployeeSearchProps> = ({ defaultValue = '', onSearch }) => {
  const [value, setValue] = useState(defaultValue);
  const debouncedSearch = useDebounce(onSearch, 300);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    debouncedSearch(e.target.value.trim());
  };

  return <Input placeholder="Search employees by name or ID" value={value} onChange={handleChange} data-cy="labor-review-search" />;
};
